import { Component } from 'engine/ecs';

export class Spin extends Component {}
